import { isSupportedLocale } from '@/i18n/config';

/** Reviewed routes only. Unlisted forms and editors keep reload admission closed. */
export function getRouteReloadOwners(
  pathname: string
): readonly string[] | null {
  const path = pathname.replace(/\/$/, '') || '/';
  const parts = path.split('/').slice(1);
  const localeOffset =
    parts[0] === 'i18n' && parts[1] && isSupportedLocale(parts[1])
      ? 2
      : parts[0] && isSupportedLocale(parts[0])
        ? 1
        : 0;
  const publicPath = `/${parts.slice(localeOffset).join('/')}`;
  if (/^\/(?:pricing|terms|privacy)$/.test(publicPath))
    return ['work-chat-pending-sends:*'];
  if (publicPath === '/')
    return ['marketing-composer:*', 'work-chat-pending-sends:*'];
  if (/^\/[^/]+\/(?:design|threads\/[^/]+)$/.test(path))
    return [
      'org-chat-composer:*',
      'org-chat-draft-hydration:*',
      'org-chat-upload-lifecycle:*',
      'org-chat-draft:*',
      'work-chat-pending-sends:*',
    ];
  return null;
}
